"use client";
import React, { useRef, useState } from "react";
import { Box, Icon } from "@chakra-ui/react";
import Image from "next/image";
import { CgPlayButtonO } from "@onemind-services-llc/react-icons-ng/cg";
import Thumbnail from "public/homevideo/VideoThumbnail.png";

const VideoPlayerWithOverlay = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <Box position="relative" width="100%" maxW={"645px"} maxH={"360px"}>
      <video
        ref={videoRef}
        width="100%"
        height="100%"
        style={{ maxHeight: "360px", maxWidth: "645px" }}
        controls
      >
        <source src="/homevideo/OmsVideo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {!isPlaying && (
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex="1"
        >
          <Image
            src={Thumbnail}
            alt="OMS Logo"
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
          />
          <Icon
            as={CgPlayButtonO}
            w={16}
            h={16}
            zIndex="2"
            aria-label="Play Button"
            cursor={"pointer"}
            onClick={handlePlay}
            position="absolute"
            color="white"
          />
        </Box>
      )}
    </Box>
  );
};

export default VideoPlayerWithOverlay;
